import client from '../../graphql/client'
import { CURRENT_USER } from '../../graphql/query/me'
import { setMixpanelPeople } from '../../utils/mixpanel'

export const VERIFICATION_TRIGGERS = {
  SEND_BROADCAST: 'send_broadcast',
  SCHEDULE_BROADCAST: 'schedule_broadcast',
  ACTIVATE_AUTOMATION: 'activate_automation',
  ENABLE_AUTORESPONDER: 'enable_autoresponder',
  PUBLISH_LANDING_PAGE: 'publish_landing_page',
  NONE: 'none',
}

// Action-level gates apply to MailMunch only.
// Appflows keeps the app-wide /verify-email wall in PrivateRoute.
export function userRequiresEmailVerification(user) {
  return (
    window.isMailmunch &&
    user?.isCreatedAfter &&
    typeof user?.isVerified === 'boolean' &&
    !user?.isVerified
  )
}

export function getCurrentUserFromCache() {
  try {
    return client.readQuery({ query: CURRENT_USER })?.me || null
  } catch {
    return null
  }
}

// Stamp verification status on event-time context + Mixpanel people profile.
export function setVerificationTracking(isVerified) {
  const verified = !!isVerified
  window.eventProperties = {
    ...(window.eventProperties || {}),
    verified,
  }
  setMixpanelPeople({ verified })
}

// Resolve which Mixpanel trigger to use for an email activate/send action.
// Alias exported as getEmailActivationTrigger for callers.
export function getEmailActivationTrigger({ type, sendSchedule } = {}) {
  if (type === 'autoresponder') return VERIFICATION_TRIGGERS.ENABLE_AUTORESPONDER
  if (type === 'broadcast' || type === 'consent' || type === 'contact-email') {
    return sendSchedule === 'now'
      ? VERIFICATION_TRIGGERS.SEND_BROADCAST
      : VERIFICATION_TRIGGERS.SCHEDULE_BROADCAST
  }
  // drip / other activate paths that send email
  return VERIFICATION_TRIGGERS.ENABLE_AUTORESPONDER
}
